module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 64
// module chunks = 0